import { render, staticRenderFns } from "./AutomatorBlocks.vue?vue&type=template&id=6bcc4470&scoped=true&"
import script from "./AutomatorBlocks.vue?vue&type=script&lang=js&"
export * from "./AutomatorBlocks.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorBlocks.vue?vue&type=style&index=0&id=6bcc4470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc4470",
  null
  
)

export default component.exports